/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUserSessionsResponseItem } from './GetUserSessionsResponseItem';
import {
    GetUserSessionsResponseItemFromJSON,
    GetUserSessionsResponseItemFromJSONTyped,
    GetUserSessionsResponseItemToJSON,
    GetUserSessionsResponseItemToJSONTyped,
} from './GetUserSessionsResponseItem';

/**
 * 
 * @export
 * @interface GetUserSessionsResponse
 */
export interface GetUserSessionsResponse {
    /**
     * 
     * @type {Array<GetUserSessionsResponseItem>}
     * @memberof GetUserSessionsResponse
     */
    sessions: Array<GetUserSessionsResponseItem>;
}

/**
 * Check if a given object implements the GetUserSessionsResponse interface.
 */
export function instanceOfGetUserSessionsResponse(value: object): value is GetUserSessionsResponse {
    if (!('sessions' in value) || value['sessions'] === undefined) return false;
    return true;
}

export function GetUserSessionsResponseFromJSON(json: any): GetUserSessionsResponse {
    return GetUserSessionsResponseFromJSONTyped(json, false);
}

export function GetUserSessionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserSessionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'sessions': ((json['sessions'] as Array<any>).map(GetUserSessionsResponseItemFromJSON)),
    };
}

export function GetUserSessionsResponseToJSON(json: any): GetUserSessionsResponse {
    return GetUserSessionsResponseToJSONTyped(json, false);
}

export function GetUserSessionsResponseToJSONTyped(value?: GetUserSessionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessions': ((value['sessions'] as Array<any>).map(GetUserSessionsResponseItemToJSON)),
    };
}

